export default function CoupounCardFloat(props: any) {
    return (
        <svg width="1167" height="300" viewBox="0 0 1167 300" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M196.992 167.163L184.314 166.732C183.483 166.704 182.876 167.508 183.131 168.3L185.717 176.328C185.97 177.113 186.922 177.415 187.581 176.919L197.674 169.321C198.578 168.64 198.123 167.201 196.992 167.163Z"
                fill="url(#paint0_linear_2364_35526)"
                stroke="url(#paint1_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="214.055"
                cy="31.1691"
                r="3.2"
                transform="rotate(-34.3971 214.055 31.1691)"
                fill="url(#paint2_linear_2364_35526)"
                stroke="url(#paint3_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="87.055"
                cy="295.17"
                r="3.2"
                transform="rotate(-34.3971 87.055 295.17)"
                fill="url(#paint4_linear_2364_35526)"
                stroke="url(#paint5_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <path
                d="M659.188 103.43L693.419 94.2249C694.222 94.009 694.567 93.0624 694.092 92.3803L680.624 73.0388C680.153 72.3617 679.154 72.3514 678.669 73.0187L657.906 101.566C657.24 102.481 658.095 103.724 659.188 103.43Z"
                fill="url(#paint6_linear_2364_35526)"
                stroke="url(#paint7_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="936.706"
                cy="6.70532"
                r="5.6227"
                transform="rotate(3.06982 936.706 6.70532)"
                fill="url(#paint8_linear_2364_35526)"
                stroke="url(#paint9_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="946.37"
                cy="286.37"
                r="4.35339"
                transform="rotate(3.06982 946.37 286.37)"
                fill="url(#paint10_linear_2364_35526)"
                stroke="url(#paint11_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="1162.26"
                cy="128.37"
                r="4.35339"
                transform="rotate(3.06982 1162.26 128.37)"
                fill="url(#paint12_linear_2364_35526)"
                stroke="url(#paint13_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <circle
                cx="616.371"
                cy="67.3699"
                r="4.35339"
                transform="rotate(3.06982 616.371 67.3699)"
                fill="url(#paint14_linear_2364_35526)"
                stroke="url(#paint15_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <path
                d="M696.948 263.313C697.098 263.044 697.084 262.723 696.973 262.389C696.861 262.055 696.643 261.682 696.34 261.28C695.732 260.475 694.752 259.516 693.485 258.465C690.947 256.362 687.224 253.866 682.915 251.474C678.606 249.081 674.519 247.24 671.392 246.198C669.831 245.678 668.498 245.354 667.494 245.263C666.992 245.218 666.56 245.23 666.218 245.312C665.875 245.394 665.596 245.553 665.446 245.822C665.296 246.092 665.31 246.413 665.421 246.747C665.533 247.081 665.751 247.454 666.054 247.856C666.662 248.661 667.642 249.62 668.909 250.671C671.447 252.774 675.17 255.27 679.479 257.662C683.788 260.054 687.875 261.895 691.002 262.937C692.563 263.458 693.896 263.782 694.9 263.872C695.402 263.917 695.834 263.905 696.176 263.823C696.519 263.742 696.798 263.583 696.948 263.313Z"
                fill="url(#paint16_linear_2364_35526)"
                stroke="url(#paint17_linear_2364_35526)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_2364_35526" x1="210.516" y1="169.816" x2="201.708" y2="186.621" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_2364_35526" x1="204.307" y1="165.079" x2="206.384" y2="172.047" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_2364_35526" x1="217.055" y1="24.6066" x2="221.745" y2="31.3632" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_2364_35526" x1="213.639" y1="26.2845" x2="217.51" y2="26.4046" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_2364_35526" x1="90.055" y1="288.608" x2="94.7448" y2="295.364" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_2364_35526" x1="86.6387" y1="290.286" x2="90.5095" y2="290.406" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint6_linear_2364_35526" x1="630.802" y1="106.02" x2="639.03" y2="62.3198" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint7_linear_2364_35526" x1="647.963" y1="112.384" x2="638.534" y2="98.189" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint8_linear_2364_35526" x1="942.128" y1="-5.15684" x2="950.605" y2="7.05628" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint9_linear_2364_35526" x1="935.953" y1="-2.12396" x2="942.95" y2="-1.90687" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint10_linear_2364_35526" x1="950.524" y1="277.284" x2="957.017" y2="286.639" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint11_linear_2364_35526" x1="945.794" y1="279.607" x2="951.153" y2="279.774" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint12_linear_2364_35526" x1="1166.41" y1="119.284" x2="1172.9" y2="128.639" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint13_linear_2364_35526" x1="1161.68" y1="121.607" x2="1167.04" y2="121.774" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint14_linear_2364_35526" x1="620.524" y1="58.2843" x2="627.017" y2="67.6387" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint15_linear_2364_35526" x1="615.794" y1="60.6073" x2="621.154" y2="60.7736" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint16_linear_2364_35526" x1="648.745" y1="232.73" x2="659.542" y2="221.609" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint17_linear_2364_35526" x1="655.611" y1="240.891" x2="657.726" y2="237.133" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
